import React, { useState, useEffect } from 'react';
import { Select, Space, DatePicker, Divider, Tag } from 'antd';
import { CheckCircleOutlined, PauseCircleOutlined } from '@ant-design/icons';
import { trIncludes } from '../../../utils/trText';
const { Option } = Select;

const BusinessFilters = ({ filters, onChange, darkMode }) => {
  const [firms, setFirms] = useState([]);
  const [projects, setProjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const { API_BASE_URL: SHARED_API_BASE_URL } = require('../../../utils/config');
  const API_BASE_URL = SHARED_API_BASE_URL;

  useEffect(() => {
    const fetchBusinessData = async () => {
      try {
        const firmsResponse = await fetch(`${API_BASE_URL}/atm/query?filters=${encodeURIComponent(JSON.stringify([{"field": "fetch", "value": "firmalar"}]))}`);
        let firmsData = [];
        
        if (firmsResponse.ok) {
          const response = await firmsResponse.json();
          firmsData = response.data || [];
        }
        
        const firms = firmsData.map((firm, index) => ({
          id: index, 
          name: firm.firma_adi,
          originalId: firm.id 
        }));
        
        if (firms.length === 0) {
          firms.push(
            { id: 0, name: 'ATM POINT A.Ş.' },
            { id: 1, name: 'ATM KİRALAMA A.Ş.' },
            { id: 2, name: 'ATM İSTANBUL A.Ş.' },
            { id: 3, name: 'Neta Kiralama A.Ş' },
            { id: 4, name: 'MASEF A.Ş.' }
          );
        }

        const projectsResponse = await fetch(`${API_BASE_URL}/atm/query?filters=${encodeURIComponent(JSON.stringify([{"field": "fetch", "value": "projeler"}]))}`);
        let activeProjects = [];
        let passiveProjects = [];
        
        if (projectsResponse.ok) {
          const projectsData = await projectsResponse.json();
          activeProjects = projectsData.active_data || [];
          passiveProjects = projectsData.passive_data || [];
        }

        const allProjects = [
          ...activeProjects.map(p => ({ ...p, active: true })),
          ...passiveProjects.map(p => ({ ...p, active: false }))
        ];

        const categoriesResponse = await fetch(`${API_BASE_URL}/atm/query?filters=${encodeURIComponent(JSON.stringify([{"field": "fetch", "value": "kategoriler"}]))}`);
        let categoriesData = [];
        
        if (categoriesResponse.ok) {
          const response = await categoriesResponse.json();
          categoriesData = response.data || [];
        }
        
        const categories = categoriesData.map(cat => ({
          id: cat.id,
          name: cat.name
        }));
        
        if (categories.length === 0) {
          categories.push(
            { id: 14, name: 'Kiosk' },
            { id: 1, name: 'Normal ATM' },
            { id: 2, name: 'Drive-In' },
            { id: 3, name: 'Lobby' }
          );
        }

        setFirms(firms);
        setProjects(allProjects);
        setCategories(categories);
      } catch (error) {
        console.error('Error fetching business data:', error);
        setFirms([
          { id: 0, name: 'ATM POINT A.Ş.' },
          { id: 1, name: 'ATM KİRALAMA A.Ş.' },
          { id: 2, name: 'ATM İSTANBUL A.Ş.' }
        ]);
        setProjects([]);
        setCategories([]);
      }
    };
    
    fetchBusinessData();
  }, []);

  const handleFirmChange = (firmIds) => {
    onChange('firmIds', firmIds || []);
  };

  const handleActiveProjectChange = (activeProjectIds) => {
    onChange('activeProjectIds', activeProjectIds || []);
  };

  const handlePassiveProjectChange = (passiveProjectIds) => {
    onChange('passiveProjectIds', passiveProjectIds || []);
  };

  const handleCategoryChange = (categoryIds) => {
    onChange('categoryIds', categoryIds || []);
  };

  const getActiveProjects = () => projects.filter(p => p.active);
  const getInactiveProjects = () => projects.filter(p => !p.active);

  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <div>
        <label style={{ 
          display: 'block', 
          marginBottom: 4, 
          fontSize: 12,
          color: darkMode ? '#ccc' : '#666'
        }}>
          Firmalar (çoklu seçim)
        </label>
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Firma seçin"
          value={filters.firmIds || []}
          onChange={handleFirmChange}
          allowClear
          showSearch
          filterOption={(input, option) =>
            trIncludes(option.children, input)
          }
          maxTagCount="responsive"
        >
          {firms.map(firm => (
            <Option key={firm.id} value={firm.id}>
              {firm.name}
            </Option>
          ))}
        </Select>
        {filters.firmIds && filters.firmIds.length > 0 && (
          <div style={{ fontSize: 10, color: darkMode ? '#999' : '#666', marginTop: 2 }}>
            {filters.firmIds.length} firma seçildi
          </div>
        )}
      </div>

      <div>
        <label style={{ 
          display: 'block', 
          marginBottom: 4, 
          fontSize: 12,
          color: darkMode ? '#ccc' : '#666'
        }}>
          Aktif Projeler (çoklu seçim)
        </label>
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Aktif proje seçin"
          value={filters.activeProjectIds || []}
          onChange={handleActiveProjectChange}
          allowClear
          showSearch
          filterOption={(input, option) => {
            const projectName = option.title || '';
            return trIncludes(projectName, input);
          }}
          maxTagCount="responsive"
        >
          {getActiveProjects().map(project => (
            <Option key={project.id} value={project.id} title={project.ad}>
              <Tag color="green" size="small" style={{ marginRight: 4 }}>
                <CheckCircleOutlined />
              </Tag>
              {project.ad}
            </Option>
          ))}
        </Select>
        {filters.activeProjectIds && filters.activeProjectIds.length > 0 && (
          <div style={{ fontSize: 10, color: darkMode ? '#999' : '#666', marginTop: 2 }}>
            {filters.activeProjectIds.length} aktif proje seçildi
          </div>
        )}
      </div>

      <div>
        <label style={{ 
          display: 'block', 
          marginBottom: 4, 
          fontSize: 12,
          color: darkMode ? '#ccc' : '#666'
        }}>
          Pasif Projeler (çoklu seçim)
        </label>
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Pasif proje seçin"
          value={filters.passiveProjectIds || []}
          onChange={handlePassiveProjectChange}
          allowClear
          showSearch
          filterOption={(input, option) => {
            const projectName = option.title || '';
            return trIncludes(projectName, input);
          }}
          maxTagCount="responsive"
        >
          {getInactiveProjects().map(project => (
            <Option key={project.id} value={project.id} title={project.ad}>
              <Tag color="orange" size="small" style={{ marginRight: 4 }}>
                <PauseCircleOutlined />
              </Tag>
              {project.ad}
            </Option>
          ))}
        </Select>
        {filters.passiveProjectIds && filters.passiveProjectIds.length > 0 && (
          <div style={{ fontSize: 10, color: darkMode ? '#999' : '#666', marginTop: 2 }}>
            {filters.passiveProjectIds.length} pasif proje seçildi
          </div>
        )}
      </div>

      <div>
        <label style={{ 
          display: 'block', 
          marginBottom: 4, 
          fontSize: 12,
          color: darkMode ? '#ccc' : '#666'
        }}>
          Kategoriler (çoklu seçim)
        </label>
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Kategori seçin"
          value={filters.categoryIds || []}
          onChange={handleCategoryChange}
          allowClear
          showSearch
          filterOption={(input, option) =>
            trIncludes(option.children, input)
          }
          maxTagCount="responsive"
        >
          {categories.map(category => (
            <Option key={category.id} value={category.id}>
              {category.name}
            </Option>
          ))}
        </Select>
        {filters.categoryIds && filters.categoryIds.length > 0 && (
          <div style={{ fontSize: 10, color: darkMode ? '#999' : '#666', marginTop: 2 }}>
            {filters.categoryIds.length} kategori seçildi
          </div>
        )}
      </div>
    </Space>
  );
};

export default BusinessFilters;
